export default "__VITE_ASSET__CdiaLHlL__"